export const uk = {
    'click-value': 'Цена клика: {value}',
    holidays: 'По праздникам',
    time: 'Время',
    'time-correction': 'Корректировка ставки по времени',
    timezone: 'Часовой пояс',
    'with-working-weekends': 'Учитывать рабочие выходные'
};
